#version 300 es
/*
* Preprocessed + Optimized from './adjust-color.frag'
* [Embedded string is compressed]
*/
precision mediump float;
precision highp int;

uniform mediump sampler2D uTexture;
uniform float brightness;
uniform float contrast;
uniform float saturation;
uniform float u_intensity;

in vec2 vTextureCoord;
layout(location = 0) out vec4 fragColor;

void main()
{
    vec4 _132 = texture(uTexture, vTextureCoord);
    float _183 = _132.w;
    vec4 _204 = vec4(((vec4(_132.xyz * (brightness + 1.0), _183).xyz - vec3(0.5)) * (contrast + 1.0)) + vec3(0.5), _183);
    float _226 = dot(_204.xyz, vec3(0.2989999949932098388671875, 0.58700001239776611328125, 0.114000000059604644775390625));
    fragColor = mix(_132, mix(vec4(_226, _226, _226, _183), _204, vec4(1.0 + saturation)), vec4(u_intensity));
}
